import { useQueryClient } from "@tanstack/react-query";
import { getCapitalActivitySummaryRetrieveQueryKey } from "gen/endpoints/capital-activity/capital-activity";
import { useFundFamilyEventDelete } from "gen/endpoints/fund-family-event/fund-family-event";
import { useTranslation } from "react-i18next";
import { useConfirmationDialog } from "shared/components/modal/confirm/ConfirmationDialog";
import { DeleteConfirmationDialog } from "shared/components/modal/DeleteConfirmationDialog";

export interface ConfirmCapitalEventDeleteArgs {
  fundFamilyEventId: string;
}

export const useConfirmCapitalEventDelete = (
  fundFamilyId: string,
  onSuccess?: () => void,
) => {
  const { t } = useTranslation(["capitalActivity"]);
  const queryClient = useQueryClient();

  const { mutateAsync: deleteFundFamilyEvent } = useFundFamilyEventDelete({
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: getCapitalActivitySummaryRetrieveQueryKey(fundFamilyId),
        });
        onSuccess?.();
      },
    },
  });

  return useConfirmationDialog(
    DeleteConfirmationDialog as DeleteConfirmationDialog<ConfirmCapitalEventDeleteArgs>,
    {
      title: t("capitalActivity:capitalEventDeleteDialog.title"),
      description: t("capitalActivity:capitalEventDeleteDialog.description"),
      successMessage: t("capitalActivity:capitalEventDeleteDialog.success"),
      performDelete: ({ fundFamilyEventId }) =>
        deleteFundFamilyEvent({
          fundFamilyId,
          fundFamilyEventId,
        }),
    },
  );
};
